<template>
    <auth-layout :image="1" :isProgressBarHidden="true">
        <common-content-wrapper width="small">
            <common-page-header :heading="heading">
                <template #content>{{ content }}</template>
            </common-page-header>
            <br />
            <auth-verify-token-form @status-change="pageStatus = $event"></auth-verify-token-form>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import AuthLayout from '@/components/layouts/AuthLayout'
    import AuthVerifyTokenForm from '@/components/forms/auth/AuthVerifyTokenForm'

    export default {
        components: {
            AuthLayout,
            AuthVerifyTokenForm,
        },

        data() {
            return {
                pageStatus: this.$route.query.token ? 'verifying' : 'manual',
            }
        },

        computed: {
            heading() {
                if (this.pageStatus === 'verifying') return this.$t('pages.auth.verify_token.heading_verifying')
                if (this.pageStatus === 'needs_npi') return this.$t('pages.auth.verify_token.heading_confirm_npi')
                if (this.pageStatus === 'token_only') return this.$t('pages.auth.verify_token.heading_token_only')
                return this.$t('pages.auth.verify_token.heading')
            },

            content() {
                if (this.pageStatus === 'verifying') return this.$t('pages.auth.verify_token.content_verifying')
                if (this.pageStatus === 'needs_npi') return this.$t('pages.auth.verify_token.content_confirm_npi')
                if (this.pageStatus === 'token_only') return this.$t('pages.auth.verify_token.content_token_only')
                return this.$t('pages.auth.verify_token.content')
            },
        },
    }
</script>
